import { useQuery } from "@tanstack/react-query";
import axiosInstance from "../../../../config/apiConfig";

const getBlogs = async (params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    if (params.pageNumber) queryParams.append('pageNumber', params.pageNumber);
    if (params.pageSize) queryParams.append('pageSize', params.pageSize);
    if (params.userId) queryParams.append('userId', params.userId);

    const { data } = await axiosInstance.get(`/Blog/paginated?${queryParams.toString()}`);
    return data || null;
  } catch (error) {
    console.error("Error fetching blogs:", error);
    return null;
  }
};

const useBlogs = (params = {}) => {
  return useQuery({
    queryKey: ["blogs", params],
    queryFn: () => getBlogs(params),
    enabled: !!params,
    keepPreviousData: true,
  });
};

export default useBlogs;

